var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editProduct_main"},[_c('pad-head-panel3',{attrs:{"title":'编辑商品',"isShowHome":true}}),_vm._v(" "),_c('div',{staticClass:"am_con"},[_c('product-detail',{attrs:{"type":'edit',"editId":_vm.id}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler?{"id":"data-v-2c62128a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/padViews/product/editProduct.vue
// module id = null
// module chunks = 